export var HdsIconlibraryThirdPartyLogos_16px;
(function (HdsIconlibraryThirdPartyLogos_16px) {
    HdsIconlibraryThirdPartyLogos_16px["i360Solid_16px"] = "360_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["AlexaSolid_16px"] = "alexa_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["AmexSolid_16px"] = "amex_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["DinersOutline_16px"] = "diners_outline_16px";
    HdsIconlibraryThirdPartyLogos_16px["DinersSolid_16px"] = "diners_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["DiscoverOutline_16px"] = "discover_outline_16px";
    HdsIconlibraryThirdPartyLogos_16px["DiscoverSolid_16px"] = "discover_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["FacebookSolid_16px"] = "facebook_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["FigmaSolid_16px"] = "figma_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["GithubSolid_16px"] = "github_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["GitlabSolid_16px"] = "gitlab_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["InstagramSolid_16px"] = "instagram_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["LinkedinSolid_16px"] = "linkedin_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["MastercardOutline_16px"] = "mastercard_outline_16px";
    HdsIconlibraryThirdPartyLogos_16px["MastercardSolid_16px"] = "mastercard_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["RedditSolid_16px"] = "reddit_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["StorybookSolid_16px"] = "storybook_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["TwitterSolid_16px"] = "twitter_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["VisaOutline_16px"] = "visa_outline_16px";
    HdsIconlibraryThirdPartyLogos_16px["VisaSolid_16px"] = "visa_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["What_3WordsOutline_16px"] = "what-3-words_outline_16px";
    HdsIconlibraryThirdPartyLogos_16px["What_3WordsSolid_16px"] = "what-3-words_solid_16px";
    HdsIconlibraryThirdPartyLogos_16px["YoutubeSolid_16px"] = "youtube_solid_16px";
})(HdsIconlibraryThirdPartyLogos_16px = HdsIconlibraryThirdPartyLogos_16px || (HdsIconlibraryThirdPartyLogos_16px = {}));
export const HDS_ICONLIBRARY_THIRD_PARTY_LOGOS_16PX_CODEPOINTS = {
    [HdsIconlibraryThirdPartyLogos_16px.i360Solid_16px]: '61697',
    [HdsIconlibraryThirdPartyLogos_16px.AlexaSolid_16px]: '61698',
    [HdsIconlibraryThirdPartyLogos_16px.AmexSolid_16px]: '61699',
    [HdsIconlibraryThirdPartyLogos_16px.DinersOutline_16px]: '61700',
    [HdsIconlibraryThirdPartyLogos_16px.DinersSolid_16px]: '61701',
    [HdsIconlibraryThirdPartyLogos_16px.DiscoverOutline_16px]: '61702',
    [HdsIconlibraryThirdPartyLogos_16px.DiscoverSolid_16px]: '61703',
    [HdsIconlibraryThirdPartyLogos_16px.FacebookSolid_16px]: '61704',
    [HdsIconlibraryThirdPartyLogos_16px.FigmaSolid_16px]: '61705',
    [HdsIconlibraryThirdPartyLogos_16px.GithubSolid_16px]: '61706',
    [HdsIconlibraryThirdPartyLogos_16px.GitlabSolid_16px]: '61707',
    [HdsIconlibraryThirdPartyLogos_16px.InstagramSolid_16px]: '61708',
    [HdsIconlibraryThirdPartyLogos_16px.LinkedinSolid_16px]: '61709',
    [HdsIconlibraryThirdPartyLogos_16px.MastercardOutline_16px]: '61710',
    [HdsIconlibraryThirdPartyLogos_16px.MastercardSolid_16px]: '61711',
    [HdsIconlibraryThirdPartyLogos_16px.RedditSolid_16px]: '61712',
    [HdsIconlibraryThirdPartyLogos_16px.StorybookSolid_16px]: '61713',
    [HdsIconlibraryThirdPartyLogos_16px.TwitterSolid_16px]: '61714',
    [HdsIconlibraryThirdPartyLogos_16px.VisaOutline_16px]: '61715',
    [HdsIconlibraryThirdPartyLogos_16px.VisaSolid_16px]: '61716',
    [HdsIconlibraryThirdPartyLogos_16px.What_3WordsOutline_16px]: '61717',
    [HdsIconlibraryThirdPartyLogos_16px.What_3WordsSolid_16px]: '61718',
    [HdsIconlibraryThirdPartyLogos_16px.YoutubeSolid_16px]: '61719',
};
//# sourceMappingURL=hds-iconlibrary-third-party-logos-16px.js.map